import { useApolloClient } from '@apollo/client';

import { NumberFormat } from '@/modules/common/types';
import { NUMBER_FORMAT } from '@/services/graphql/queries';

import useEnhancedQuery from './use-enhanced-query';

const useNumberFormat = () => {
  const client = useApolloClient();

  const { data, loading, error } = useEnhancedQuery(NUMBER_FORMAT, {
    fetchPolicy: 'cache-only',
  });

  const setNumberFormat = (numberFormat: NumberFormat | undefined | null) => {
    client.writeQuery({
      query: NUMBER_FORMAT,
      data: {
        numberFormat,
      },
    });
  };

  return { numberFormat: data?.numberFormat as NumberFormat, loading, error, setNumberFormat };
};

export default useNumberFormat;
